module.exports = __webpack_public_path__ + "973795240c655e3f375f09aebc91e276.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2107_teaser_image.jpg
// module id = 601
// module chunks = 0